import _ from 'lodash';
import { PageStore, PageStoreProps, Status } from '@/main/store/@types/page';
import { DropdownList } from '@/main/store/@types/dropdown.d';
import { PageModule } from '@/main/store/@types/store.d';
import { storesMap } from '@/main/store/registry';

import { pageGetters } from '../getters';
import { mutations } from './mutations';


export function pageStateBuilder<
	TDropdownList extends DropdownList,
	TLocalState extends object,
	TProps extends PageStoreProps,
>({
	name,
	crumbLabel,
	dropdownList,
	localState,
	props,
}: {
	name: string,
	crumbLabel: string,
	dropdownList: TDropdownList,
	localState: TLocalState,
	props: TProps,
}): PageStore<TDropdownList, TLocalState, TProps> {
	return {
		crumb: {
			label: crumbLabel,
			detail: null,
		},
		loadingCount: 0,
		mainCollapse: [],
		activeTabName: '',
		name,
		operations: null,
		validationRules: null,
		requestCancelTokens: {},
		refreshPreviousPage: false,
		status: Status.ok,

		dropdownList: _.cloneDeep(dropdownList),
		localState: _.cloneDeep(localState),
		props: _.cloneDeep(props),
	};
}

export function pageStoreBuilder<
	TDropdownList extends DropdownList,
	TLocalState extends object,
	TProps extends PageStoreProps,
>({
	name,
	crumbLabel,
	dropdownList,
	localState,
	props,
}: {
	name: string,
	crumbLabel: string,
	dropdownList: TDropdownList,
	localState: TLocalState,
	props: TProps,
}): PageModule<PageStore<TDropdownList, TLocalState, TProps>, {}, typeof mutations, typeof pageGetters> {
	type State = PageStore<TDropdownList, TLocalState, TProps>;

	const store = {
		namespaced: true as true,
		state(): State {
			return pageStateBuilder({ name, crumbLabel, dropdownList, localState, props });
		},
		actions: {},
		getters: pageGetters,
		mutations,
	};
	storesMap.set(name, _.cloneDeep(store));
	return store;
}
